"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const feature_toggle_json_1 = __importDefault(require("../../../feature-toggle.json"));
class FeatureToggleStore {
    constructor() {
        this._featureToggles = new Map(Object.entries(feature_toggle_json_1.default));
    }
    get featureToggles() {
        return this._featureToggles;
    }
    add(featureName, status) {
        this._featureToggles.set(featureName, status);
    }
}
__decorate([
    mobx_1.observable
], FeatureToggleStore.prototype, "_featureToggles", void 0);
__decorate([
    mobx_1.computed
], FeatureToggleStore.prototype, "featureToggles", null);
__decorate([
    mobx_1.action
], FeatureToggleStore.prototype, "add", null);
exports.default = new FeatureToggleStore();
